import { BigNumber, BigNumberish } from 'ethers'

export function diff(a: BigNumberish, b: BigNumberish) {
  const aBn = BigNumber.from(a)
  const bBn = BigNumber.from(b)
  if (aBn.gte(bBn)) {
    return aBn.sub(bBn)
  } else {
    return bBn.sub(aBn)
  }
}
